import { t } from '@lingui/core/macro';
import clsx from 'clsx';
import { DriveStep } from 'driver.js';
import { THandleTourCloseParams } from './useTutorials.types';

export const createRelaunchPortalToursStep = (
  onComplete: () => void,
): DriveStep => ({
  element: '#account-icon-button',
  popover: {
    title: t`🧭 Relaunch Portal tours`,
    description: t`<p>You can always relaunch the tours by <strong>clicking your profile icon.</strong></p><p>We hope you enjoy using the Portal!</p>`,
    side: 'bottom',
    align: 'end',
    popoverClass: clsx('driver-popover-custom', 'relaunch-tour-popover'),
    nextBtnText: renderTranslatedText('got it'),
    onNextClick: onComplete,
  },
  disableActiveInteraction: true,
});

export const addRelaunchStepWhenApplicable = (
  steps: DriveStep[],
  enabled: boolean,
  onComplete: () => void,
) => {
  if (!enabled) return;
  steps.push(createRelaunchPortalToursStep(onComplete));
};

export const closeTourOrJumpToFinalStep = ({
  tour,
  autoTriggered,
  onTourComplete,
}: THandleTourCloseParams) => {
  const steps = tour.getConfig()?.steps;
  const activeStep = tour.getActiveStep();

  if (!steps || steps.length === 0) {
    tour.destroy();
    return;
  }

  const lastStepIndex = steps.length - 1;

  const activeStepIndex =
    activeStep &&
    steps.findIndex(
      (step) =>
        step.element === activeStep.element &&
        step.popover?.title === activeStep.popover?.title,
    );

  // only mark tour as complete when its on the last step of the tour (relaunch portal tours step)
  if (autoTriggered && onTourComplete && activeStepIndex === lastStepIndex) {
    onTourComplete();
  }

  if (!autoTriggered || activeStepIndex === lastStepIndex) {
    tour.destroy();
  } else {
    tour.moveTo(lastStepIndex);
  }
};

export const renderTranslatedText = (text: 'got it' | 'next') => {
  return text === 'got it' ? t`Got it` : t`Next`;
};

export const renderProgressText = (step: number, stepCount: number) => {
  return t`${step} of ${stepCount}`;
};
